import { render } from "./Masthead.vue?vue&type=template&id=3aa36e2c&ts=true"
import script from "./Masthead.vue?vue&type=script&lang=ts"
export * from "./Masthead.vue?vue&type=script&lang=ts"
/* custom blocks */
import block0 from "./Masthead.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__